import styled from "@emotion/styled";
import { Columns, FlexRow, H2 } from "atoms";
import { ReviewableCard } from "features/reviewable";
import { useReviewableList } from "features/search";
import { ViewAllLink } from "./ViewAllLink";

function MintingNow() {
  const { data: mintingNow } = useReviewableList("minting-now");

  return (
    <>
      <Header>
        <FlexRow alignItems="center" justifyContent="space-between">
          <H2>Currently Minting: Our&nbsp;Favorites</H2>
          <ViewAllLink to="/search?mintStatus=currently+minting">
            View all
          </ViewAllLink>
        </FlexRow>
      </Header>

      {mintingNow && (
        <Columns cols={4}>
          {mintingNow.data.map((project) => (
            <ReviewableCard entity={project} key={project.id} />
          ))}
        </Columns>
      )}
    </>
  );
}

const Header = styled.header({
  padding: "2rem 0",
  h2: {
    margin: 0,
  },
});
export { MintingNow };
